var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{staticClass:"shrink mr-2",attrs:{"alt":`${_vm.name} Logo`,"contain":"","src":_vm.logo,"position":"center left","transition":"scale-transition","width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }